import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { useIsSuperadmin } from '@/hooks/admin/useIsSuperadmin';

/**
 * Index-route landing: APBG staff (superadmins) go straight into the admin
 * portal ("Settings"), landing on the Quick order tab for phone orders;
 * customers go to their /home dashboard. Staff only enter a customer's
 * context deliberately — via Quick order → Start order, or the customer
 * page's "Act as customer".
 */
export function LandingRedirect() {
  const { isSuperadmin, loading } = useIsSuperadmin();

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center py-16 text-sm text-brix-muted">
        <Loader2 size={16} className="animate-spin mr-2" />
        Loading…
      </div>
    );
  }
  return <Navigate to={isSuperadmin ? '/admin/quick-order' : '/home'} replace />;
}
